import { Navigate, Outlet } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { verificationStatus } from "../constants/commonConstants";

// NOTE: Component for protected common routes
export const ProtectedRoute = () => {
  const { isAuthenticated, verificationStatus: currentStatus } = useSelector(
    (state) => state.auth,
  );

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (
    currentStatus === verificationStatus.REJECTED ||
    currentStatus === verificationStatus.PENDING
  ) {
    return <Navigate to="/signin" replace />;
  }

  return <Outlet />;
};

// NOTE: Handle Public Routes
export const PublicRoute = () => {
  const dispatch = useDispatch();

  return <Outlet />;
};
